/*
 * @Author: your name
 * @Date: 2020-12-07 18:02:15
 * @LastEditTime: 2020-12-09 20:37:16
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/service/basic/exceptionApiList.js
 */
const dataReportApiList = {
  getDataboard: "/system/shop/databoard", // 获取数据看板信息
  getDatareport: "/system/shop/datareport", // 获取店铺数据报表
  getSystemWs: "/system/ws", // 当服务端数据看板的值有变动时，主动推送变动的值
  getPendingOrder: "/system/order/pendingorderlist" // 待处理工单列表
};
export default dataReportApiList;



// WEBPACK FOOTER //
// ./src/service/basic/dataReportApiList.js